<form [formGroup]="form" fxFlex>
	<mat-form-field fxFlex="50">
		<mat-icon matPrefix>search</mat-icon>
		<input formControlName="search" matInput placeholder="Search">
		<mat-icon (click)="clearSearch()" *ngIf="form?.controls?.search?.value?.length > 0 && !loadingResults"
				  matSuffix>clear
		</mat-icon>
		<mat-spinner *ngIf="loadingResults" color="primary" diameter="24" matSuffix></mat-spinner>
		<mat-error>
			{{'placeOrderView.searchCriteria' | translate}}
		</mat-error>
	</mat-form-field>
</form>
